"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.errors.stepsLoadFailed': '加载步骤失败',
    'tutorial.errors.avatarsLoadFailed': '加载头像失败',
    'tutorial.errors.companiesLoadFailed': '加载公司失败',
    'tutorial.errors.loadFailed': '加载教程失败',
};
